import {
  apiClient,
  ApiError,
  PaginatedApiResponse,
  ApiResponse,
} from "@/lib/apiClient";
import { Variant } from "@/types/models/product";

export const getInventory = async ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}): Promise<PaginatedApiResponse<Variant[]>> => {
  try {
    const data: PaginatedApiResponse<Variant[]> = await apiClient.getPaginated(
      "/api/v1/admin/:storeId/products/inventory",
      {
        page: page.toString(),
        page_size: pageSize.toString(),
      },
    );
    return data;
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
export const updateInventoryAction = async ({
  product_id,
  variant_id,
  inventory,
}: {
  product_id: string;
  variant_id: string;
  inventory: number;
}): Promise<ApiResponse<Variant[]>> => {
  try {
    const response: ApiResponse<Variant[]> = await apiClient.put(
      `/api/v1/admin/:storeId/products/inventory/`,
      {
        items: [
          {
            inventory: inventory,
            product_id: product_id,
            variant_id: variant_id,
          },
        ],
      },
    );
    return {
      data: response.data,
      status: response.status,
      message: response.message,
      success: response.success,
      valid: response.valid,
    };
  } catch (error: unknown) {
    if (error instanceof ApiError) {
      throw error;
    }
    throw new ApiError(500, "UNKNOWN_ERROR", "An unexpected error occurred");
  }
};
